/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { h } from 'vue';
import Text from '../Text.js';
import '../props.js';
import '../utils/uid.js';
import '../constant.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useSpotCheck = function useSpotCheck() {
  var checkSpotType = function checkSpotType(_ref) {
    var props = _ref.props,
        items = _ref.items,
        point = _ref.point,
        i = _ref.i,
        hasSpotlight = _ref.hasSpotlight;

    if (!props.hasSpot && !hasSpotlight) {
      return true;
    }

    if (!props.hasSpot && props.spotlight === i) {
      items.push(h(Text, _objectSpread(_objectSpread({}, props), {}, {
        text: "".concat(props.data[props.spotlight]),
        point: point
      })));
      return true;
    }

    return false;
  };

  return {
    checkSpotType: checkSpotType
  };
};

export { useSpotCheck as default };
//# sourceMappingURL=useSpotCheck.js.map
